import { BadgeCheck } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface VerifiedBadgeProps {
  isVerified: boolean | null | undefined;
  fundraiserType?: string | null;
  size?: "sm" | "md" | "lg";
  showTooltip?: boolean;
  className?: string;
}

export const VerifiedBadge = ({
  isVerified,
  fundraiserType,
  size = "md",
  showTooltip = true,
  className,
}: VerifiedBadgeProps) => {
  if (!isVerified) return null;

  const sizeClasses = {
    sm: "h-3.5 w-3.5",
    md: "h-4 w-4",
    lg: "h-5 w-5",
  };

  const badge = (
    <div className={cn("inline-flex items-center", className)}>
      <BadgeCheck className={cn(sizeClasses[size], "text-primary fill-primary/20")} />
    </div>
  );

  if (!showTooltip) return badge;

  const tooltipText = fundraiserType === 'organization' 
    ? "Verified Organization" 
    : "Verified Fundraiser";

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {badge}
      </TooltipTrigger>
      <TooltipContent>
        <p className="text-xs">{tooltipText}</p>
      </TooltipContent>
    </Tooltip>
  );
};
